import React from 'react';

import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface BarChartProps {
    labels: string[];
    itemsData: number[];
}

const BarChart: React.FC<BarChartProps> = (props) => {
    const { labels, itemsData } = props;

    const data = {
        labels: labels,
        datasets: [
            {
                // label: "Ventes",
                data: itemsData,
                backgroundColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                    'rgba(153, 102, 255, 1)',
                    'rgba(255, 159, 64, 1)',
                    'rgba(255, 99, 99, 1)',
                    'rgba(54, 75, 235, 1)',
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                    'rgba(153, 102, 255, 1)',
                    'rgba(255, 159, 64, 1)',
                    'rgba(255, 99, 99, 1)',
                    'rgba(54, 75, 235, 1)',
                ],
                borderWidth: 1,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        const label = data.labels[tooltipItem.dataIndex];
                        const value = data.datasets[0].data[tooltipItem.dataIndex];
                        return `${label}: ${value.toLocaleString('fr-FR', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })}€`;
                    },
                    title: function () {
                        return '';
                    },
                },
                backgroundColor: 'rgba(0, 0, 0, 0.7)', // Couleur de fond du tooltip
                titleFont: {
                    size: 16,
                },
                bodyFont: {
                    size: 14,
                },
                borderColor: 'rgba(255, 255, 255, 0.5)', // Couleur de la bordure du tooltip
                borderWidth: 1,
            },
        },
        scales: {
            y: {
                beginAtZero: true, // Commence l'axe des Y à zéro
            },
        },
    };

    return <Bar data={data} options={options} />;
};

export default BarChart;
